<template>
  <div id="SECFilings">
      <div v-if="data">
        <h1 align="center">SEC Filings</h1>
        <a v-bind:href="data.sec_link">SEC Edgar</a>
      </div>
  </div>
</template>
<script>
import axios from 'axios';
// import VueApexCharts from 'vue-apexcharts';


export default {
  name: 'SECFilingsComponent',
  props: ['ticker'],
  data() {
    return {
        // ticker: 'AAPL',
        data: null,
    }
  },
  // computed: {},
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let params = {
        'ticker':this.ticker,
      }
      await axios
        .get(`${process.env.VUE_APP_DATA_API_HOST}/filings`, {params:params})
        .then(response => {
          this.data = response.data['data']
        })
        .catch(e => {
          e
        })
    },
  },
  watch:{
    ticker:function(){
      this.fetchData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>